import React, { useEffect, useMemo, useState } from "react";
import { getHsUid } from "../happyschool_static/hsAuth";
import { fetchCatalog, fetchAttempts } from "./quiz3Utils";

// TQ-10 — lịch sử/tiến độ cá nhân: danh sách lượt đã làm, điểm theo thời
// gian, lọc theo môn/chủ đề.
const Quiz3History = () => {
  const [uid, setUid] = useState(null);
  const [attempts, setAttempts] = useState({});
  const [quizzes, setQuizzes] = useState({});
  const [subjects, setSubjects] = useState({});
  const [subjectFilter, setSubjectFilter] = useState("all");
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    setUid(getHsUid());
  }, []);

  useEffect(() => {
    let cancelled = false;
    // Chỉ cần tên đề/môn -> catalog nhẹ thay cho /api/all.
    fetchCatalog()
      .then((data) => {
        if (cancelled) return;
        setQuizzes(data.quizzes || {});
        setSubjects(data.subjects || {});
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!uid) return;
    let cancelled = false;
    fetchAttempts()
      .then((a) => {
        if (!cancelled) setAttempts(a || {});
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [uid]);

  const list = useMemo(() => {
    return Object.entries(attempts)
      .map(([id, a]) => ({ id, ...a, quiz: quizzes[a.quizId] }))
      .filter((a) => (subjectFilter === "all" ? true : a.quiz?.subjectId === subjectFilter))
      .sort((a, b) => (b.submittedAt || 0) - (a.submittedAt || 0));
  }, [attempts, quizzes, subjectFilter]);

  if (!uid) return <div style={{ padding: 24, color: "#6b7280" }}>Bạn cần đăng nhập để xem lịch sử làm bài.</div>;

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 4px 0" }}>Lịch sử làm bài</h2>
      <p style={{ color: "#6b7280", marginTop: 0, marginBottom: 16 }}>Các lượt bạn đã làm, mới nhất trước.</p>

      <select
        value={subjectFilter}
        onChange={(e) => setSubjectFilter(e.target.value)}
        style={{ padding: "6px 10px", border: "1px solid #d1d5db", borderRadius: 8, marginBottom: 16 }}
      >
        <option value="all">Tất cả môn học</option>
        {Object.entries(subjects).map(([id, s]) => (
          <option key={id} value={id}>
            {s.name}
          </option>
        ))}
      </select>

      {list.length === 0 && <p style={{ color: "#6b7280" }}>Chưa có lượt làm bài nào.</p>}

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {list.map((a) => (
          <div key={a.id} style={rowStyle}>
            <div
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}
              onClick={() => setExpandedId(expandedId === a.id ? null : a.id)}
            >
              <div>
                <p style={{ margin: "0 0 4px 0", fontWeight: 600 }}>{a.quiz?.title || "Đề đã bị xóa"}</p>
                <p style={{ margin: 0, fontSize: 12, color: "#6b7280" }}>
                  {subjects[a.quiz?.subjectId]?.name || ""} · {a.submittedAt ? new Date(a.submittedAt).toLocaleString("vi-VN") : ""}
                </p>
              </div>
              <span style={scoreBadgeStyle(a.score, a.totalQuestions)}>
                {a.score}/{a.totalQuestions}
              </span>
            </div>
            {expandedId === a.id && (
              <div style={{ marginTop: 10, borderTop: "1px solid #e5e7eb", paddingTop: 10 }}>
                <p style={{ fontSize: 13, color: "#6b7280" }}>
                  Bắt đầu: {a.startedAt ? new Date(a.startedAt).toLocaleString("vi-VN") : "?"} · Nộp bài:{" "}
                  {a.submittedAt ? new Date(a.submittedAt).toLocaleString("vi-VN") : "?"}
                </p>
                <p style={{ fontSize: 13, color: "#6b7280" }}>Số câu đã làm: {a.questionIds?.length || 0}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const rowStyle = {
  padding: 14,
  border: "1px solid #e5e7eb",
  borderRadius: 10,
  background: "#fff",
};

const scoreBadgeStyle = (score, total) => {
  const ratio = total ? score / total : 0;
  const color = ratio >= 0.8 ? "#16a34a" : ratio >= 0.5 ? "#d97706" : "#dc2626";
  return {
    fontWeight: 700,
    color,
    fontSize: 15,
  };
};

export default Quiz3History;
